import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/settings/purchase-orders")({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: location.href.replace(/^\/settings\/purchase-orders/, "/settings/procurement"),
      replace: true,
    })
  },
})
